<template lang="html">
  <div class="area-wrapper">
    <chooseAddress
      v-model="area"
      :districtId="areaCode || '320102'"
      :cityID="selectedCity || '320100'"
      :twoSelect="true"
    ></chooseAddress>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import chooseAddress from '../address/atom/choose'

export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      area: ''
    }
  },
  watch: {
    async area(val, oldVal) {
      if (oldVal !== '') {
        if (val.over) {
          this.setOriginPlace(val)
          this.hideActionSheet(false)
          let areaCode = ''
          if (this.originPlace.regionid && this.originPlace.regionid !== '') {
            areaCode = this.originPlace.regionid.split('_')[2]
          }
        }
      }
    }
  },
  computed: {
    ...mapState(['originPlace']),
    areaCode() {
      let areaCode = ''
      if (this.originPlace.regionid && this.originPlace.regionid !== '') {
        areaCode = this.originPlace.regionid.split('_')[2]
      }
      return areaCode
    },
    selectedCity() {
      if (this.params) {
        return this.params.cityId
      }
    }
  },
  methods: {
    ...mapMutations(['setOriginPlace', 'hideActionSheet'])
  },
  components: {
    chooseAddress
  }
}
</script>

<style lang="scss" scoped>
.area-wrapper {
  height: 100%;
}
</style>
